import { createSlice } from '@reduxjs/toolkit';
import { LegalState } from '../types/legal.types';
import { fetchGuardianInfo, updateGuardianInfo } from '../actions/legal.actions';

const LEGAL_DEFAULT_STATE: LegalState = {
    guardianInfo: {},
    loading: false,
    error: null,
    updating: false,
    duplicatedEmail: false
};

const DUPLICATED_ERROR_CODE = 'errors.com.epicgames.ecommerce.payout.taxprofile.email_duplicated';

export const legalSlice = createSlice({
    name: 'legal',
    initialState: LEGAL_DEFAULT_STATE,
    reducers: {
        clearError: (state) => {
            state.error = null;
            state.duplicatedEmail = false;
        },
        resetDuplicatedEmail: (state) => {
            state.duplicatedEmail = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGuardianInfo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGuardianInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.guardianInfo = action.payload;
                state.error = null;
            })
            .addCase(fetchGuardianInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updateGuardianInfo.pending, (state) => {
                state.updating = true;
                state.error = null;
            })
            .addCase(updateGuardianInfo.fulfilled, (state, action) => {
                state.updating = false;
                state.guardianInfo = action.payload;
                state.error = null;
            })
            .addCase(updateGuardianInfo.rejected, (state, action) => {
                state.updating = false;
                if (action.payload === DUPLICATED_ERROR_CODE) {
                    state.duplicatedEmail = true;
                }
                state.error = action.payload as string;
            });
    }
});

export const { clearError, resetDuplicatedEmail } = legalSlice.actions;
export const legalReducer = legalSlice.reducer;
